import TensaiService from '../../services/tensai';

// actions
export const SEND_RECOVER_PASSWORD_EMAIL = 'SEND_RECOVER_PASSWORD_EMAIL';
export const PASSWORD_UPDATED = 'PASSWORD_UPDATED';
export const TOKEN_VALIDATION = 'TOKEN_VALIDATION';
export const RESET_EMAIL = 'RESET_EMAIL';

// action: Envia email de recuperação de senha para o servidor
export function sendRecoverPasswordEmail(email, dispatch) {
  const service = new TensaiService();
  const dataPromise = service.sendRecoverPasswordEmail(email);
  dispatch({ type: SEND_RECOVER_PASSWORD_EMAIL, payload: dataPromise });
}

// action: Envia o token e a senha a ser atualizada para o servidor
export function updatePassword(token, password, dispatch) {
  const service = new TensaiService();
  const dataPromise = service.updatePassword(token, password);
  dispatch({ type: PASSWORD_UPDATED, payload: dataPromise });
}

// action: verifica no servidor se o token é valido
export function tokenValidation(token, dispatch) {
  const service = new TensaiService();
  const dataPromise = service.isTokenValid(token);
  dispatch({ type: TOKEN_VALIDATION, payload: dataPromise });
}

// reset Email
export function resetEmail(dispatch) {
  dispatch({ type: RESET_EMAIL });
}
